module.exports = __webpack_public_path__ + "static/img/activity_sdy_01-2.11868da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_01-2.jpg
// module id = 5Duc
// module chunks = 0